let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aNM5M")).then(() => parcelRequire('dqRYQ'));